module.exports = __webpack_public_path__ + "assets/img/avatar-7.dc910b2a.jpg";